import { render, staticRenderFns } from "./WhatsappCampanhaView.vue?vue&type=template&id=1fac7238"
import script from "./WhatsappCampanhaView.vue?vue&type=script&lang=js"
export * from "./WhatsappCampanhaView.vue?vue&type=script&lang=js"
import style0 from "./WhatsappCampanhaView.vue?vue&type=style&index=0&id=1fac7238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports